export default __webpack_public_path__ + "static/media/Logo-Black@2x.a7ae4662.svg";